import { Component, Input, OnInit } from '@angular/core';
import AddressHelper from 'src/app/helpers/address-helper';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import Company from 'src/app/model/company/company';
import ProjectContact from 'src/app/model/company/projectContact';
import IPBoardArrows from 'src/app/model/product/ip-board/ip-board-arrows';
import SecondBoard from 'src/app/model/product/ip-board/second-board';
import AddressWithType from 'src/app/model/project/address-with-type';
import { SubProject } from 'src/app/model/project/sub-project';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';

@Component({
  selector: 'client-adjustment-pending-executed',
  templateUrl: './client-adjustment-pending-executed.component.html',
  styleUrls: ['./client-adjustment-pending-executed.component.scss'],
  providers: [FormatPhoneNumber],
})
export class ClientAdjustmentPendingExecutedComponent implements OnInit {
  @Input()
  type: string;

  @Input()
  adjustment: SubProject;

  @Input()
  projectContacts: ProjectContact[];

  @Input()
  arrows: IPBoardArrows;

  @Input()
  secondBoard: SecondBoard;

  @Input()
  otherOrderPlacementInfo: string;

  @Input()
  executed: boolean = false;

  collectKeyFromCompany: Company;
  collectKeyFromAddress: AddressWithType;

  constructor(private formatPhoneNumber: FormatPhoneNumber) {}

  ngOnInit(): void {
    if (this.adjustment.projectPlacement.appointmentContact != null) {
      ContactHelper.setFormDisplays(
        this.adjustment.projectPlacement.appointmentContact,
        this.formatPhoneNumber
      );
    }
    if (this.adjustment.projectPlacement.collectKeyFrom != null) {
      const projectContact = this.projectContacts.find(
        (pc) =>
          pc.company != null &&
          pc.company.id === this.adjustment.projectPlacement.collectKeyFrom
      );
      this.collectKeyFromCompany = projectContact.company;
      this.collectKeyFromAddress =
        projectContact == null || projectContact.company == null
          ? null
          : AddressHelper.getAddressPreferring(
              projectContact.company.addresses,
              this.adjustment.projectPlacement.collectKeyAddressType
            );
    }
  }
}
